import { SET_DATE_RANGE, SET_SEARCH_VALUE } from './actionCreator';

const initialState = {
  searchValue: '',
  dateRange: [],
};

const searchFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_VALUE:
      return {
        ...state,
        searchValue: action.payload,
      };
    case SET_DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };
    default:
      return state;
  }
};

export default searchFilterReducer;
